import { PatientConsentViewModel } from "./PatientConsentViewModel";
export class PatientConsentWelcomeBackViewModel extends PatientConsentViewModel {
    goToSavedRoute() {
        this.patientConsentUIManager.goToSavedWelcomeBackPage();
    }
    startFromBeginning() {
        this.patientConsentUIManager.startFromBeginning();
    }
}
